import React, { useState } from "react";
import {
  Grid,
  CardActionArea,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import SpokeIcon from "@mui/icons-material/Spoke";
import SdvUploadDialog from "./SdvUploadDialog";
import { useQuery } from "react-query";
import { getSdvFeatureDataCount } from "../../services/SdvFeature";
import DottedTile from "../common/DottedTile";
import InfoTile from "../common/InfoTile";

const SdvFeatureStats = () => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);

  const { data: { data: { sdvFeatureCount = 0 } = {} } = {} } = useQuery(
    "getSdvFeatureDataCount",
    getSdvFeatureDataCount,
    {
      refetchOnWindowFocus: false,
    }
  );

  const onClose = () => {
    setOpenModal(false);
  };

  const dialogProps = {
    openModal,
    onClose,
    setOpenModal,
  };

  return (
    <>
       <Grid item xs={6} md={2}>
        <InfoTile
          title={"Total Features"}
          info={sdvFeatureCount || "0"}
        />
      </Grid>

      <Grid item xs={6} md={2}>
         <CardActionArea onClick={handleOpen}>
            <DottedTile title={"CREATE FEATURE"}>
              <SpokeIcon sx={{ fontSize: "3.5rem", color: grey[500] }} />
            </DottedTile>
          </CardActionArea>
      </Grid>
      <SdvUploadDialog {...dialogProps} />
    </>
  );
};
export default SdvFeatureStats;
